import React, {useContext, useEffect, useState} from "react";
import {Spinner} from "@blueprintjs/core";
import {goVehisService} from "../../utils/axios";
import AppToaster from "../AppToaster";
import {SellerContext} from "../../context/seller-context";
import SellerCodeReader from "../../utils/SellerCodeReader";
import Validator from "../../utils/Validator";
import analyitics from "../../utils/analytics";
import arrowRight from "../../assets/images/icons/arrow_circle_right_white.svg";

function ContactForm(props) {

    const seller = useContext(SellerContext);
    let sellerCodeReader = new SellerCodeReader();

    const [status, setStatus] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [contactForm, setContactForm] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        agreement: true,
        marketingElectronic: false,
        marketingPhone: false,
        sourceUrl: window.location.href,
        sellerEmail: seller.email,
        sellerPhone: seller.phone,
        sellerCode: sellerCodeReader.readSellerCode(),
    });

    useEffect(() => {
        setContactForm(prevState => ({
            ...prevState,
            sellerEmail: seller.email,
            sellerPhone: seller.phone,
            sellerCode: sellerCodeReader.readSellerCode(),
        }));
    }, [seller]);

    useEffect(() => {
        if (Validator.nonNumbersExistsInString(contactForm.phone)) {
            setContactForm(prevState => ({
                ...prevState,
                phone: contactForm.phone.slice(0, -1)
            }));
        }
    }, [contactForm.phone]);

    const valueChangeHandler = (event) => {
        const {name, value} = event.target;
        setContactForm(prevState => ({...prevState, [name]: value}));
    };

    const checkboxChangeHandler = (event) => {
        const {name, checked} = event.target;
        setContactForm(prevState => ({...prevState, [name]: checked}));
    };

    const submitFormHandler = (event) => {
        event.preventDefault();
        if (isSubmitting) return;

        let contactFormData = {...contactForm};
        let additionalMessage = props.additionalMessage ? props.additionalMessage + " - " : "";
        contactFormData.message = additionalMessage + contactForm.message;

        setIsSubmitting(true);

        goVehisService.post("/sellers/contact", contactFormData)
            .then(response => {
                AppToaster.show({message: response.data, intent: "primary"});
                setStatus("success");
                setContactForm(prevState => ({
                    ...prevState,
                    name: "",
                    email: "",
                    phone: "",
                    message: "",
                    marketingElectronic: false,
                    marketingPhone: false,
                }));
                if (props.onSuccess) {
                    analyitics.sendEvent({
                        category: 'Kontakt',
                        action: 'Wysłanie wiadomości'
                    });
                    props.onSuccess();
                }
            })
            .catch(() => {
                AppToaster.show({message: "Ups! Wystąpił jakiś błąd. Spróbuj ponownie.", intent: "danger"});
                setStatus("error");
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    return (
        <div id="contact-form">
            <form onSubmit={submitFormHandler}>

                <div className="contact-form-field">
                    <label className="contact-form-label" htmlFor="contact-name">Imię i nazwisko</label>
                    <input
                        className="contact-form-input"
                        required
                        type="text"
                        id="contact-name"
                        name="name"
                        value={contactForm.name}
                        onChange={valueChangeHandler}
                        placeholder=""
                    />
                </div>

                <div className="contact-form-row">
                    <div className="contact-form-field">
                        <label className="contact-form-label" htmlFor="contact-phone">Nr telefonu</label>
                        <input
                            className="contact-form-input"
                            required
                            type="text"
                            id="contact-phone"
                            name="phone"
                            minLength="9"
                            maxLength="9"
                            pattern="[0-9]{9}"
                            value={contactForm.phone}
                            onChange={valueChangeHandler}
                            placeholder=""
                        />
                    </div>
                    <div className="contact-form-field">
                        <label className="contact-form-label" htmlFor="contact-email">Adres e-mail</label>
                        <input
                            className="contact-form-input"
                            required
                            type="email"
                            id="contact-email"
                            name="email"
                            value={contactForm.email}
                            onChange={valueChangeHandler}
                            placeholder=""
                        />
                    </div>
                </div>

                <div className="contact-form-field">
                    <label className="contact-form-label" htmlFor="contact-message">Wiadomość</label>
                    <input
                        className="contact-form-input"
                        required
                        type="text"
                        id="contact-message"
                        name="message"
                        value={contactForm.message}
                        onChange={valueChangeHandler}
                        placeholder=""
                    />
                </div>

                <div className="contact-form-consents">
                    <p className="contact-form-consent-text">
                        Przesłanie formularza oznacza wyrażenie zgody na przetwarzanie moich danych osobowych
                        w celu umożliwienia kontaktu drogą telefoniczną lub/i elektroniczną.
                        Więcej informacji o przetwarzaniu danych osobowych i wycofaniu zgody{" "}
                        <a href="/rodo" target="_blank" rel="noreferrer">tutaj.</a>
                    </p>

                    <div className="search-checkbox-row">
                        <input
                            type="checkbox"
                            id="marketing-electronic"
                            name="marketingElectronic"
                            checked={contactForm.marketingElectronic}
                            onChange={checkboxChangeHandler}
                        />
                        <label htmlFor="marketing-electronic">
                            Wyrażam zgodę na otrzymywanie informacji marketingowych za pomocą środków
                            komunikacji elektronicznej. Więcej informacji{" "}
                            <a href="https://go-leasing.pl/polityka-prywatnosci/" target="_blank" rel="noreferrer">tutaj</a>.
                        </label>
                    </div>

                    <div className="search-checkbox-row">
                        <input
                            type="checkbox"
                            id="marketing-phone"
                            name="marketingPhone"
                            checked={contactForm.marketingPhone}
                            onChange={checkboxChangeHandler}
                        />
                        <label htmlFor="marketing-phone">
                            Wyrażam zgodę na otrzymywanie informacji marketingowych przy użyciu
                            telekomunikacyjnych urządzeń końcowych oraz automatycznych systemów wywołujących.
                            Więcej informacji{" "}
                            <a href="https://go-leasing.pl/polityka-prywatnosci/" target="_blank" rel="noreferrer">tutaj</a>.
                        </label>
                    </div>
                </div>

                {status === "success" && (
                    <p className="home-newsletter-success">Dziękujemy! Wiadomość została wysłana.</p>
                )}
                {status === "error" && (
                    <p className="home-newsletter-error">Ups! Wystąpił błąd. Spróbuj ponownie.</p>
                )}

                <button type="submit" className="contact-form-submit" disabled={isSubmitting}>
                    {isSubmitting ? "wysyłanie" : "wyślij"}
                    {isSubmitting
                        ? <Spinner size={20} className="contact-form-submit-spinner"/>
                        : <img src={arrowRight} alt="" className="contact-form-submit-icon"/>}
                </button>

            </form>
        </div>
    );
}

export default ContactForm;
